import { render, staticRenderFns } from "./BaseStatistics.vue?vue&type=template&id=7e70ed53&scoped=true&"
import script from "./BaseStatistics.vue?vue&type=script&lang=js&"
export * from "./BaseStatistics.vue?vue&type=script&lang=js&"
import style0 from "./BaseStatistics.vue?vue&type=style&index=0&id=7e70ed53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e70ed53",
  null
  
)

export default component.exports